import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

import { onBreakpointChanged, removeOnBreakpointChanged, getCurrentBreakpoints } from '@/utils/viewport';
import {
  computed, provide,
  ref, RendererNode, onBeforeUnmount, useSlots, VNode, onBeforeMount, watch,
} from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseGridRow',
  props: {
    start: { type: Boolean },
    center: { type: Boolean },
    end: { type: Boolean },
    verticalStart: { type: Boolean },
    verticalCenter: { type: Boolean },
    verticalEnd: { type: Boolean },
    minHeight: {},
    noGap: { type: Boolean },
    defaultColSize: {},
    small: { type: Boolean },
    large: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

provide('defaultColSize', props.defaultColSize);

const classes = computed(() => {
  const classesArr = [];

  if (props.center) {
    classesArr.push('justify-content-center');
  } else if (props.end) {
    classesArr.push('justify-content-end');
  } else if (props.start) {
    classesArr.push('justify-content-start');
  }

  if (props.verticalCenter) {
    classesArr.push('align-items-center');
  } else if (props.verticalEnd) {
    classesArr.push('align-items-end');
  } else if (props.verticalStart) {
    classesArr.push('align-items-start');
  }

  if (props.noGap) {
    classesArr.push('no-gap');
  }

  if (props.small) {
    classesArr.push('small-gap');
  } else if (props.large) {
    classesArr.push('large-gap');
  }

  return classesArr;
});

const slots = useSlots();
const slotDefault = computed(() => (slots.default ? slots.default() : null));
const colItems = ref<VNode<RendererNode>[]>([]);

const setColItems = (event: CustomEvent) => {
  const breakpoints = (event.detail?.breakpoints || ['xs']) as string[];

  colItems.value = [...(slotDefault.value || [])].map((item, inx) => {
    const mappedItem = { ...item };
    let order = inx;

    if (typeof item.props?.order === 'object') {
      let orderByBp: undefined | number;
      const propBps = mappedItem.props?.order;
      breakpoints.forEach((bpKey) => {
        if (Object.keys(propBps).includes(bpKey)) {
          if (propBps[bpKey] !== undefined) {
            orderByBp = propBps[bpKey];
          }
        }
      });

      order = typeof orderByBp === 'number' ? orderByBp : order;
    }

    mappedItem.props = {
      ...item.props,
      order,
    };

    return mappedItem;
  });
};

watch(() => slotDefault.value, () => {
  setColItems({
    detail: {
      breakpoints: getCurrentBreakpoints(),
    },
  } as unknown as CustomEvent);
});

onBeforeMount(() => {
  onBreakpointChanged(setColItems, true);
});

onBeforeUnmount(() => {
  removeOnBreakpointChanged(setColItems);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["app-grid__row", classes.value]),
    style: _normalizeStyle({
        minHeight: `${ typeof _ctx.minHeight === 'number' ? (`${_ctx.minHeight}px`) : _ctx.minHeight }`
      })
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(colItems.value, (colItem, inx) => {
      return (_openBlock(), _createBlock(_resolveDynamicComponent(colItem), {
        key: `col-item-${inx}`
      }))
    }), 128))
  ], 6))
}
}

})